import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_py-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_external_login_actions = _resolveComponent("external-login-actions")
  const _component_login_form = _resolveComponent("login-form")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_external_login_actions, {
      "return-url": $options.returnUrl,
      class: "_mb-3",
      onSuccess: $options.onLoginSuccess
    }, null, 8 /* PROPS */, ["return-url", "onSuccess"]),
    _createVNode(_component_login_form, {
      "return-url": $options.returnUrl,
      onSuccess: $options.onLoginSuccess
    }, null, 8 /* PROPS */, ["return-url", "onSuccess"])
  ]))
}